import request from "@/utils/request";

export function unZipToFile(data) {
  return request({
    url: "Upload/UnZipToFile",
    method: "post",
    data,
  });
}

export function unZip(data) {
  return request({
    url: "Upload/unZip",
    method: "post",
    data,
  });
}

export function readFiles(data) {
  return request({
    url: "Upload/ReadFiles",
    method: "post",
    data,
  });
}

export function readDbfFiles(data) {
  return request({
    url: "Upload/ReadDbfFiles",
    method: "post",
    data,
  });
}

export function readSWSFiles(data) {
  return request({
    url: "Upload/ReadSWSFiles",
    method: "post",
    data,
  });
}

export function uploadXHLFile(data) {
  return request({
    url: "Upload/UploadXHLFile",
    method: "post",
    data,
  });
}

export function readXhlFile(data) {
  return request({
    url: "PrevalenceRate/ReadXhlFile",
    method: "post",
    data,
  });
}


// WEBPACK FOOTER //
// ./src/api/upload.js